import { Card, CardContent, Checkbox, Grid, Typography } from "@mui/material";
import CardHeaderColor from "components/MuiExtras/Card/CardHeaderColor";
import MuiClickable from "components/MuiExtras/MuiClickable";
import { getTranslatedSystemRoles } from "lib/TranslationUtils";
import { SystemRoles } from "models/ApiEnums";
import { SelectableGroupShortView } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";
import UserGroupsWithPermissionsDrawer from "views/User/Dialogs/UserGroupsWithPermissionsDrawer";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    dialog: any;
}

interface IProps {
    groups: string[];
    ownRoles: SystemRoles;
    groupsRoles: SystemRoles;
    onChange: (v: SystemRoles) => void;
    onSelectedGroupsChange: (g: SelectableGroupShortView[]) => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class UserEditRole extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = { dialog: null };
    }

    ///
    private handlePermission(role: SystemRoles) {
        const { ownRoles, onChange } = this.props;

        if ((ownRoles & role) == 0) {
            if ((role == SystemRoles.PublisherVideo || role == SystemRoles.PublisherAdvancedOptions) && (ownRoles & SystemRoles.Publisher) == 0)
                role |= SystemRoles.Publisher;
            onChange(ownRoles | role);
        }
        else {
            if (role == SystemRoles.Publisher) {
                if ((ownRoles & SystemRoles.PublisherVideo) > 0) role |= SystemRoles.PublisherVideo;
                if ((ownRoles & SystemRoles.PublisherAdvancedOptions) > 0) role |= SystemRoles.PublisherAdvancedOptions;
            }
            onChange(ownRoles ^ role);
        }
    }

    ///
    private handleRoleInheritance(role: SystemRoles) {
        this.setState({
            dialog: (
                <UserGroupsWithPermissionsDrawer
                    groups={this.props.groups}
                    role={role}
                    onClose={
                        (groups) => {
                            if (groups) this.props.onSelectedGroupsChange(groups);
                            this.setState({ dialog: null });
                        }
                    }
                />
            )
        });
    }

    ///
    render() {

        const { ownRoles, groupsRoles } = this.props;

        var roles = getTranslatedSystemRoles();//.sort((a, b) => a.value.localeCompare(b.value));

        return (
            <>
                {this.state.dialog}
                <Card>
                    <CardHeaderColor color="primary" title={this.props.t("Views.User.Components.UserEditRole.HeaderTitle")} />

                    <CardContent>
                        {
                            roles
                                .filter(p =>
                                    p.key != SystemRoles.None
                                    && p.key != SystemRoles.All
                                    && (p.key != SystemRoles.Administrator || Session.hasRole(SystemRoles.Administrator))
                                )
                                .map((role, index) => {

                                    const inherit = (groupsRoles & role.key) > 0;
                                    const hasOwnRole = (ownRoles & role.key) > 0;
                                    return (
                                        <Grid key={index} container justifyContent="center" alignItems="flex-start" columnSpacing={2}>
                                            <Grid item>
                                                {
                                                    (role.key == SystemRoles.PublisherVideo || role.key == SystemRoles.PublisherAdvancedOptions) &&
                                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                }
                                                <Checkbox
                                                    checked={inherit || hasOwnRole}
                                                    disabled={inherit}
                                                    onClick={() => this.handlePermission(role.key)}
                                                    style={{ padding: 0 }}
                                                />
                                            </Grid>
                                            <Grid item xs>
                                                <div>
                                                    <Typography variant="body2" color="primary">
                                                        {role.value}
                                                    </Typography></div>
                                                <div>
                                                    {
                                                        inherit
                                                            ? (
                                                                <MuiClickable onClick={() => this.handleRoleInheritance(role.key)}>
                                                                    <Typography variant="body2" color="secondary"><small>{this.props.t("Common.Literals.InheritedText")}</small></Typography>
                                                                </MuiClickable>
                                                            )
                                                            : null
                                                    }
                                                </div>
                                            </Grid>
                                        </Grid>
                                    );
                                })
                        }
                    </CardContent>

                </Card>
            </>
        );
    }
}

export default withTranslation()(UserEditRole);